import { Component, EventEmitter, Output } from '@angular/core';
import {
    NavController,
    ModalController,
    LoadingController
} from 'ionic-angular';

import { Observable, Subscription } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';

import { AlertMessager } from '../../../lib/alertMessager';

import { RodeoService } from '../../../services/rodeo.service';
import { Rodeo } from '../../../model/rodeo';
import { SearchOptions } from '../../../model/searchOptions';
import { AccountHelper } from '../../../lib/accountHelper';
import { DrawResults } from '../../rodeo/draw-results';
import { Organization } from '../../../model/organization';
import { OrganizationService } from '../../../services/organization.service';
import { RodeoSetupPage } from './rodeo-setup';
import { MembershipService } from '../../../services/membership.service';

@Component({
    selector: 'rodeo-list',
    templateUrl: 'rodeo-list.html'
})
export class RodeoListPage {
    rodeoResults: Rodeo[] = [];
    organizations: Organization[] = [];
    loadingData: boolean = false;

    popoverActive: boolean;

    organizationFilter: any = { name: 'All' };
    searchText: string = "";

    admin: boolean;
    prompted: boolean;
    subscriptions: Subscription[] = [];

    rodeoFilter: string = "All";

    searchOptions: SearchOptions = new SearchOptions();
    textSearchChangeObservable: any;

    @Output() rodeoSelected = new EventEmitter<Rodeo>();

    constructor(public nav: NavController, private rodeoService: RodeoService, private organizationService: OrganizationService,
        private alert: AlertMessager, private modalCtrl: ModalController, private loadingControl: LoadingController, private membershipService: MembershipService) { }

    load() {
        this.admin = AccountHelper.instance().isNextGenAdmin();
        this.search();

        this.organizationService.getOrganizations()
            .then(data => {
                this.organizations = (data as Organization[]);
                this.organizations = this.organizations.filter(x => AccountHelper.instance().isStaffOfOrganization(x));
            });
    }

    addNewRodeo(rodeo: Rodeo) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(RodeoSetupPage, {}, { cssClass: 'rodeo-setup', enableBackdropDismiss: true });

        entryModal.present().then(() => {
            this.popoverActive = false;
        })

        entryModal.onDidDismiss((data) => {
            if (data != null) {
                if (this.nav.last()) {
                    this.rodeoSelected.emit(data);
                }
            }
        });
    }

    selectRodeo(rodeo: Rodeo) {
        if (this.nav.last()) {
            let loading = this.loadingControl.create({
                content: 'Retrieving Rodeo Information...',
            });

            loading.present();
            this.rodeoService.getRodeo(rodeo.id)
                .then(data => {
                    (data as Rodeo).organization.memberships.forEach((membership) => {
                        this.membershipService.getMembershipDiscounts(membership.id)
                            .then (discounts => {
                                membership.discounts = discounts;
                            })
                    });

                    this.loadingData = false;
                    loading.dismiss();

                    (data as Rodeo).rodeoEvents.forEach((rodeoEvent) => {
                        rodeoEvent.eventType = rodeoEvent.eventType.split(' ').join('');
                    });

                    this.rodeoSelected.emit(data as Rodeo);
                });
        }
    }

    onTextSearchChange() {
        if (!this.textSearchChangeObservable) {
            Observable.create(observer => {
                this.textSearchChangeObservable = observer;
            }).debounceTime(750)
                .distinctUntilChanged()
                .subscribe((text) => { this.search() });
        }

        this.textSearchChangeObservable.next(this.searchText);
    }

    matchOrgNames(a, b) {
        return a.name.toLocaleLowerCase() == b.name.toLocaleLowerCase();
    }

    search() {
        if (this.loadingData)
            return;

        this.searchOptions.searchText = this.searchText;
        this.searchOptions.staffSearch = true;
        this.searchOptions.organizations = [];

        if (this.organizationFilter != null && this.organizationFilter.name != 'All')
            this.searchOptions.organizations.push(this.organizationFilter);

        if (this.rodeoFilter === "Open") {
            this.searchOptions.showOpen = true;
            this.searchOptions.showUpcoming = false;
        } else if (this.rodeoFilter === "Upcoming") {
            this.searchOptions.showOpen = false;
            this.searchOptions.showUpcoming = true;
        } else {
            this.searchOptions.showOpen = false;
            this.searchOptions.showUpcoming = false;
        }

        let loading = this.loadingControl.create({
            content: 'Retrieving events...',
        });

        loading.present();

        this.loadingData = true;

        this.rodeoService.searchRodeos(this.searchOptions)
            .then(data => {
                this.rodeoResults = [];
                Object.assign(this.rodeoResults, data);
                let currentDate = new Date();
                if (this.rodeoFilter == 'Open') {
                    this.rodeoResults = this.rodeoResults.filter(x => currentDate >= this.stripTimezone(x.registrationStartDate) && currentDate <= this.stripTimezone(x.registrationEndDate)).reverse();
                } else if (this.rodeoFilter == 'Upcoming') {
                    this.rodeoResults = this.rodeoResults.filter(x => currentDate < this.stripTimezone(x.registrationStartDate)).reverse();
                }

                loading.dismiss();
                this.loadingData = false;
            }, error => {
                console.log(error);

                if (error.status != '401')
                    this.alert.showError('Error', 'Unable to retrieve rodeos at this time.')

                loading.dismiss();
                this.loadingData = false;
            });
    }

    stripTimezone(date: string): Date {
        if (!date)
            return new Date();

        return new Date(new Date(new Date(date).getTime() + (new Date(date).getTimezoneOffset() * -60 * 1000)).toISOString().substring(0, '2011-10-05T14:48'.length));
    }

    drawRodeos() {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Drawing rodeos....'
        });

        loader.present();

        this.popoverActive = true;
        this.rodeoService.drawRodeos(null)
            .then(data => {
                let entryModal = this.modalCtrl.create(DrawResults, { results: data }, { cssClass: 'page-draw-results', enableBackdropDismiss: false });

                entryModal.present();
                entryModal.onDidDismiss((data) => {
                    this.popoverActive = false;
                });
                loader.dismiss();
            }, error => {
                console.log(error); this.alert.showError('Error', 'Unable to draw rodeos.')
                loader.dismiss();
            });
    }

    doRefresh() {
        this.search();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/rodeo-list.ts